'use client'

import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import { FormattedCurrency } from '@dustin-web/microsite-components/src/i18n'
import useShoppingCart from '@dustin-web/product-components/src/hooks/dataloader/use-shopping-cart'

export const CartTotalSummary = () => {
  const { translate } = useTranslations()

  const { totalPrice, totalQuantity } = useShoppingCart()

  return (
    <div className="c-shoppingcart__item-list-summary d-print-none">
      <strong className="d-block">
        {translate('Cart_Total')}: {totalQuantity}{' '}
        {totalQuantity === 1 ? translate('Cart_Product') : translate('Cart_Products')}
      </strong>
      <div className="c-shoppingcart__item-list-total-price">
        <strong className="d-block">
          <FormattedCurrency amount={totalPrice} />
        </strong>
      </div>
    </div>
  )
}
